import { Colors, Services, getPrice } from '@sigma-frontend-libs/commons'
import { RECURRENT_PAYMENTS_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { buttonModes, components, icons, permissionPresets } from '@/utils'

import button from '@/components/button'
import info from '@/components/info'
import eventsHistoryTab from '@/components/services/eventsHistory/tab'
import { recurrentPaymentIcons, recurrentPaymentsStatusColors } from '@/components/services/recurrentPayments/utils'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderStatus(h) {
  let statusValue
  let statusLabel
  if (this.viewport.size.width > 500 || !this.isPage) {
    statusValue = this.getTranslate(`${Services.recurrentPayments}.statuses.${this.value.status}`)
    statusLabel = this.getTranslate(`${Services.recurrentPayments}.labels.status`)
  }

  return h(
    sticker,
    {
      props: {
        value: statusValue,
        label: statusLabel,
        icon: recurrentPaymentIcons.status[this.value.status],
        iconTooltip: this.getTranslate(`${Services.recurrentPayments}.hints.statuses.${this.value.status}`),
        color: recurrentPaymentsStatusColors[this.value.status]
      }
    }
  )
}
function renderAmount(h) {
  return h(
    sticker,
    {
      props: {
        value: getPrice(this.value.amount, { currency: this.currency }),
        label: this.amountLabel,
        iconSVG: this.currency,
        color: Colors.grey
      }
    }
  )
}
function renderMethod(h) {
  if (this.viewport.size.width > 610) {
    return h(
      sticker,
      {
        props: {
          value: this.getTranslate(`${Services.payments}.methods.${this.value.method}`),
          label: this.getTranslate(`${Services.recurrentPayments}.labels.method`),
          iconSVG: this.value.method,
          iconTooltip: this.getTranslate(`${Services.payments}.methods.${this.value.method}`),
          color: Colors[this.value.method]
        }
      }
    )
  }
}
function renderPeriod(h) {
  if (this.viewport.size.width > 820) {
    return h(
      sticker,
      {
        props: {
          value: this.period,
          label: this.getTranslate(`${Services.recurrentPayments}.labels.type`)
        }
      }
    )
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 1280 && this.isPage) {
    return h(
      owner,
      {
        props: {
          value: this.value
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.recurrentPayments}-item__info`]: true,
        [`${Services.recurrentPayments}-item__info--admin`]: this.canGetUsersAsResellerUp,
        [`${Services.recurrentPayments}-item__info--page`]: this.isPage
      }
    },
    [
      renderStatus.call(this, h),
      renderAmount.call(this, h),
      renderMethod.call(this, h),
      renderPeriod.call(this, h),
      renderOwner.call(this, h)
    ]
  )
}

function renderEventHistoryDialogBody(h) {
  return h(
    eventsHistoryTab,
    {
      props: {
        entityId: this.value.id
      }
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          slot: 'footer',
          on: {
            click: () => {
              this.showEventsHistoryDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderEventHistoryDialog(h) {
  let eventsHistoryMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    eventsHistoryMaxWidth = 600
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate(`services.${Services.eventsHistory}`),
        value: this.showEventsHistoryDialog,
        maxWidth: eventsHistoryMaxWidth
      },
      on: {
        input: event => {
          this.showEventsHistoryDialog = event
        }
      }
    },
    [ renderEventHistoryDialogBody.call(this, h) ]
  )
}
function renderDialogBody(h) {
  let confirmContentKey = 'pause'
  if (this.isPaused) {
    confirmContentKey = 'resume'
  }

  return h(
    info,
    {
      props: {
        value: this.getTranslate(`${Services.recurrentPayments}.contents.confirm.${confirmContentKey}`)
      }
    }
  )
}
function renderDialogFooter(h) {
  let pauseButtonLabel = `${Services.recurrentPayments}.buttons.pause`
  let pauseButtonIcon = icons.pause
  let pauseButtonColor = Colors.primary
  if (this.isPaused) {
    pauseButtonLabel = `${Services.recurrentPayments}.buttons.resume`
    pauseButtonIcon = icons.play_arrow
    pauseButtonColor = Colors.success
  }

  return h(
    'div',
    {
      class: 'dialog__footer',
      slot: 'footer'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate('misc.buttons.close'),
            mode: buttonModes.flat
          },
          on: {
            click: () => {
              this.showDialog = false
            }
          }
        }
      ),
      h(
        button,
        {
          props: {
            label: this.getTranslate(pauseButtonLabel),
            icon: pauseButtonIcon,
            color: pauseButtonColor
          },
          on: {
            click: async () => {
              await this.activateRecurrentPayment()
              this.showDialog = false
            }
          }
        }
      )
    ]
  )
}
function renderDialog(h) {
  let dialogMaxWidth
  if (this.viewport.breakpoint.mdUp) {
    dialogMaxWidth = 400
  }

  return h(
    components.dialog,
    {
      props: {
        title: this.getTranslate('commons.titles.confirm.title'),
        value: this.showDialog,
        maxWidth: dialogMaxWidth
      },
      on: {
        input: event => {
          this.showDialog = event
        }
      }
    },
    [
      renderDialogBody.call(this, h),
      renderDialogFooter.call(this, h)
    ]
  )
}
function renderListItem(h, { show = true, permission, accept = permissionPresets.meUp, validation, callback, icon, iconColor, pathToTranslate }) {
  if (this.checkPermissions(permission, accept)) {
    if (show) {
      if (validation) {
        return h(
          components['list-item'],
          {
            props: {
              icon,
              iconColor,
              label: this.getTranslate(pathToTranslate),
              dense: true
            },
            on: {
              click: callback
            }
          }
        )
      }
    }
  }
}
function renderActions(h) {
  if (this.canUpdateRecurrentPayments) {
    let pauseListIcon = icons.pause
    let pauseListPath = `${Services.recurrentPayments}.buttons.pause`
    if (this.isPaused) {
      pauseListIcon = icons.play_arrow
      pauseListPath = `${Services.recurrentPayments}.buttons.resume`
    }

    return h(
      actions,
      {
        props: {
          value: this.value,
          actions: [ 'remove' ],
          service: Services.recurrentPayments,
          accept: permissionPresets.meUp
        }
      },
      [
        renderListItem.call(this, h, {
          permission: `advanced.${Services.recurrentPayments}.get`,
          accept: permissionPresets.managerUp,
          validation: true,
          icon: icons.history,
          callback: () => {
            return this.showEventsHistoryDialog = true
          },
          pathToTranslate: `services.${Services.eventsHistory}`
        }),
        renderListItem.call(this, h, {
          show: this.value.OwnerId === this.account.id,
          permission: `advanced.${Services.recurrentPayments}.update`,
          validation: [ RECURRENT_PAYMENTS_STATUSES.init, RECURRENT_PAYMENTS_STATUSES.error ].includes(this.value.status),
          callback: this.repeatRecurrentPayment,
          icon: icons.verified_user,
          iconColor: Colors.success,
          pathToTranslate: `${Services.recurrentPayments}.buttons.confirm`
        }),
        renderListItem.call(this, h, {
          permission: `advanced.${Services.payments}.get`,
          validation: true,
          callback: () => {
            return this.$emit(Services.payments, this.value.id)
          },
          icon: icons.history,
          pathToTranslate: `${Services.recurrentPayments}.buttons.${Services.payments}`
        }),
        renderListItem.call(this, h, {
          permission: `advanced.${Services.recurrentPayments}.update`,
          validation: ![ RECURRENT_PAYMENTS_STATUSES.init, RECURRENT_PAYMENTS_STATUSES.error ].includes(this.value.status),
          callback: () => {
            return this.showDialog = true
          },
          icon: pauseListIcon,
          iconColor: Colors.primary,
          pathToTranslate: pauseListPath
        }),
        renderListItem.call(this, h, {
          permission: `advanced.${Services.recurrentPayments}.update`,
          validation: this.value.status === RECURRENT_PAYMENTS_STATUSES.block,
          callback: () => {
            return this.$emit('unlockRecurrentPayment', this.value.id)
          },
          icon: icons.done,
          iconColor: Colors.success,
          pathToTranslate: 'misc.buttons.unlock'
        })
      ]
    )
  }
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        ['service-template-item']: true,
        [`${Services.recurrentPayments}-item`]: true,
        ['hover-parent hover-parent--opacity']: this.viewport.breakpoint.mdUp
      },
      key: this.value.id
    },
    [
      renderInfo.call(this, h),
      renderActions.call(this, h),
      renderCreatedAt.call(this, h),
      renderDialog.call(this, h),
      renderEventHistoryDialog.call(this, h)
    ]
  )
}
